// extracted by mini-css-extract-plugin
module.exports = {"largeBody":"LargeBody_largeBody__4csV5"};
module.exports.__checksum = "89003fbd68f7"
